import * as React from 'react';

export default class extends React.Component {

  public render() {
    return(
      <h1> Welcome to face-api.js </h1>
    )
  }
}